import {
  validate_file,
} from '@/utils/validations/validate_inputs';

export default {
    methods:{
        create_preview_url(fileOrBlob) {
            return URL.createObjectURL(fileOrBlob);
        },

        revoke_preview_url() {
            if (this.preview_url && String(this.preview_url).startsWith('blob:')) {
                URL.revokeObjectURL(this.preview_url);
            }
        },

        preview_file(url, name = '') {
            if (!url) return;
            this.revoke_preview_url();
            this.preview_url = url;
            this.preview_name = name || '';
            this.preview_type = this.guess_preview_type(name);
            this.preview_modal = true;
        },

        preview_local_file(fieldModel) {
            const v = Reflect.get(this.safe_form_data, fieldModel);
            if (!v) return;

            // Freshly-selected local file (File/Blob)
            if (v.file instanceof File || v.file instanceof Blob) {
                this.preview_url = {
                file: v.file,
                file_name: v.file.name,
                presigned_url: this.create_preview_url(v.file)
                };
                this.preview_modal = true;
                return;
            }

            // Existing uploaded file with presigned URL
            if (v.presigned_url || v.original_url) {
                this.preview_url = {
                presigned_url: v.presigned_url || v.original_url,
                file_name: v.file_name || ''
                };
                this.preview_modal = true;
            }
        },

        download_local_file(fieldModel) {
            const v = Reflect.get(this.safe_form_data, fieldModel);
            if (!v || !v.file) return;

            const url = URL.createObjectURL(v.file);
            const a = document.createElement('a');
            a.href = url;
            a.download = v.file.name || 'document';
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(url);
        },

        download_file(url, filename) {
            const a = document.createElement('a');
            a.href = url;
            a.download = filename;
            a.target = '_blank';
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        },

        is_pptx_file(file) {
            const extension = file.name.split('.').pop().toLowerCase();
            if (extension === 'pptx') return true;
            if (file.type === 'application/vnd.openxmlformats-officedocument.presentationml.presentation') {
                return true;
            }
            return false;
        },

        remove_file(fieldModel) {
            Reflect.set(this.safe_form_data, fieldModel, null);
            Reflect.set(this.safe_form_data, fieldModel + '_file_comment', '');
            Reflect.set(this.file_validation_error, fieldModel, null);
        },

        close_the_file_preview() {
            this.preview_modal = false;
            // Revoke blob URL if it exists
            if (this.preview_url?.presigned_url?.startsWith('blob:')) {
                URL.revokeObjectURL(this.preview_url.presigned_url);
            }
            this.preview_url = null;
        },

        close_file_preview_modal() {
            this.show_file_preview_modal = false;
            // Revoke object URL shortly after close for smoothness
            setTimeout(() => this.revoke_preview_url(), 150);
        },

        async handle_file_upload(event, fieldId, is_dependent = false) {
            let question_prefix = 'q';
            if (is_dependent) {
                fieldId = fieldId.replace(/^dq_/, '');
                question_prefix = 'dq';
            }
            const file = event.target.files[0];
            if (file) {
                if (this.is_pptx_file(file)) {
                Reflect.set(this.file_validation_error, `${question_prefix}_${fieldId}`, "PowerPoint files (.pptx) are not allowed.");
                event.target.value = null;
                return;
                }

                const result = await validate_file(file);
                if (!result.valid) {
                Reflect.set(this.file_validation_error, `${question_prefix}_${fieldId}`, result.error);
                event.target.value = null;
                return;
                }

                Reflect.set(this.file_validation_error, `${question_prefix}_${fieldId}`, null);
                Reflect.set(this.safe_form_data, `${question_prefix}_${fieldId}`, { file: file, file_name: file.name });
            }
        },
    }
}